import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Root, Title, Note } from './ReadyToStart.style';

import { Button } from '../../ui/Button/Button';
import { Link } from '../Link/Link';

export const ReadyToStart = () => {
  return (
    <Root>
      <Title>
        <FormattedMessage defaultMessage="READY TO START?" />
      </Title>
      <Button
        as={Link}
        to="/rewards/business-education-coaching-packages"
        style={{ backgroundColor: '#e74391' }}
      >
        <FormattedMessage defaultMessage="ENROLL NOW WITH POINTS" />
      </Button>
      <Note>
        <FormattedMessage defaultMessage="Not enough points? Please reach out to your Sales Representative to learn more about the Limitless Growth" />
      </Note>
    </Root>
  );
};
